// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageTitle_wrapper__w_2zI","content":"PageTitle_content__KgTVI"};